<template>
  <div
    class="canvas-container"
    ref="canvasContainer"
  >
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  name: "KoioteLabel",
  props: {
    input: Object,
  },
  mounted() {
    this.dibujarTexto();
    this.setupResizeObserver(); // Configurar el observer
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect(); // Desconectar el observer al destruir el componente
    }
  },
  methods: {
    dibujarTexto() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      const container = this.$refs.canvasContainer;

      // Establecer el tamaño del canvas igual al del contenedor
      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;

      // Limpiar el canvas antes de dibujar (borrar contenido previo)
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Establecer el color de fondo
      ctx.fillStyle = this.input.customized.background_color;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Establecer el color del texto
      ctx.fillStyle = this.input.customized.foreground_color;

      // Ajuste dinámico del tamaño de la fuente
      let fontSize = Math.floor(canvas.height / 1); // El tamaño de la fuente es el 20% de la altura del canvas

      // Asegurarse de que la fuente no sea demasiado grande
      if (fontSize > canvas.width / 2) {
        fontSize = Math.floor(canvas.width / 2); // Limitar el tamaño máximo para que el texto no se desborde
      }

      // Establecer la fuente
      ctx.font = `${fontSize}px Arial`;

      // Ajustar el tamaño de la fuente para que el texto se ajuste dentro del canvas
      while (ctx.measureText(this.input.customized.label).width > canvas.width - 20 && fontSize > 10) {
        fontSize -= 1;
        ctx.font = `${fontSize}px Arial`;
      }

      // Calcular la posición para centrar el texto
      const x = (canvas.width - ctx.measureText(this.input.customized.label).width) / 2;
      const y = canvas.height / 2 + fontSize / 4;

      // Dibujar el texto en el canvas
      ctx.fillText(this.input.customized.label, x, y);
    },

    setupResizeObserver() {
      // Crear una instancia de ResizeObserver
      this.resizeObserver = new ResizeObserver(() => {
        this.dibujarTexto(); // Redibujar el canvas cuando el tamaño cambia
      });

      // Observar el contenedor del canvas para detectar cambios de tamaño
      this.resizeObserver.observe(this.$refs.canvasContainer);
    },
  },
};
</script>

<style scoped>
.canvas-container {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 100%;
}
canvas {
  display: block;
}
</style>
